// extracted by mini-css-extract-plugin
export default {"cta":"AH-z","disabled":"BH-z"};